import $ from 'jquery';
import Component from "../models/Component";
import Headroom from "headroom.js";
import {$Doc} from "../utils/jQueryGlobals";

export default class MainMenu extends Component {
  constructor(element, context) {
    super(element, context);
    this.headroom = new Headroom(element, {
      offset: 50,
      tolerance: 5,
      onPin: () => {
        $Doc.trigger('header_pin');
      },
      onUnpin: () => {
        $Doc.trigger('header_unpin');
      },
    });
    $(() => {
      this.init();
    });
  }

  init() {
    this.headroom.init();
    this.element.find('.menu-item > a[href="#"]').on('click', () => false);
    this.element.find('.main-menu > .menu-items > .menu-item-has-children > a').on('click', (e) => {
      $(e.currentTarget).parent().toggleClass('open');
      return false;
    });
  }
}
